import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { PcnListingResults, PcnListingType } from "./shared";


export function PcnAdminOnHoldListing() {

    const dispatch = useDispatch();
   
    useEffect(() => {
        dispatch({ type: 'SITE_FULL_WIDTH' });
    }, []);

    return (
        <PcnListingResults pcnStateToShow={PcnListingType.ONHOLD} />
    );

}